import { createSlice } from "@reduxjs/toolkit";

const initialAddExternalGameState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  entities: [],
  exportData: [],
  countryList: [],
  usersCount: null,
  allCountryList: null,
  newGame: {},
  gameForEdit: {},
  countryForEdit: [],
  itemGame: {},
  itemTokens: [],
  featureImage: {},
  bannerImage: {},
  inGameNameImage: {},
  tournamentImage: {},
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const AddExternalGameSlice = createSlice({
  name: "addExternalGame",
  initialState: initialAddExternalGameState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.error = null;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    clearfetchStaffUsers: (state, action) => {
      state.listLoading = false;
      state.error = null;
      state.entities = [];
      state.totalCount = 0;
    },
    emptyList: (state, action) => {
      state.error = null;
      state.entities = [];
      // state.totalCount = 0;
      state.exportData = [];
      state.featureImage = {};
      state.bannerImage = {};
      state.inGameNameImage = {};
      state.tournamentImage = {};
    },
    // getstaffUserById
    appFlyerTokenList: (state, action) => {
      const { totalCount, entities } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.entities = entities;
      state.totalCount = totalCount;
    },
    AppFlyerTokenExport: (state, action) => {
      const { exportData } = action.payload;
      // state.listLoading = false;
      // state.error = null;
      state.exportData = exportData;
    },
    CountryList: (state, action) => {
      const { countryList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.countryList = countryList;
    },

    CountryDropdownList: (state, action) => {
      const { countryDropdownList } = action.payload;
      state.listLoading = false;
      state.error = null;
      state.totalCount = 0;
      state.countryDropdownList = countryDropdownList;
    },

    createGame: (state, action) => {
      const { newGame } = action.payload;
      state.error = null;
      state.newGame = newGame;
    },
    singleItemFetched: (state, action) => {
      console.log("hee------------------->slice",action.payload.gameForEdit)
      state.actionsLoading = false;
      state.gameForEdit = action.payload.gameForEdit;
      state.error = null;
    },

    imageUploaded: (state, action) => {
      const { entities, imageField } = action.payload;
      state.error = null;
      console.log("imageField", imageField);
      if (imageField == "featureImage") {
        state.featureImage = entities;
      }
      if (imageField == "bannerImage") {
        state.bannerImage = entities;
      }
      if (imageField == "inGameNameImage") {
        state.inGameNameImage = entities;
      }
      if (imageField == "tournamentFeaturedImage") {
        state.tournamentImage = entities;
      }
      state[imageField] = entities;
    },
  },
});
